module.exports = __webpack_public_path__ + "img/phone_1.47e03ac8.png";